import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '@ooh/contracts';
import type { Client, CreateClient, UpdateClient } from '@ooh/contracts';
import { apiQueryKey } from '../data/use-api-suspense-query';
import { useApiClient } from '../plugs/api-client';

function useInvalidateClients() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: apiQueryKey(clients.list) });
}

export function useCreateClient() {
  const api = useApiClient();
  const invalidateClients = useInvalidateClients();

  return useMutation({
    mutationFn: (body: CreateClient) => api.call(clients.create, body),
    onError: () => undefined,
    onSuccess: invalidateClients,
  });
}

export function useUpdateClient() {
  const api = useApiClient();
  const invalidateClients = useInvalidateClients();

  return useMutation({
    mutationFn: (body: { id: Client['id'] } & UpdateClient) => api.call(clients.update, body),
    onError: () => undefined,
    onSuccess: invalidateClients,
  });
}

export function useArchiveClient() {
  const api = useApiClient();
  const invalidateClients = useInvalidateClients();

  return useMutation({
    mutationFn: (id: Client['id']) => api.call(clients.delete, { id }),
    onSuccess: invalidateClients,
  });
}
